<template>
  <div>
    <b-modal no-fade id="modal-planej-original" title="Alterar Planejamento Original" size="lg" @show="doShowDados">
      <b-form-row>
        <b-col>
          <b-form-group label="Mês/Ano" label-size="sm" label-for="mes_ano">
            <date-picker
              input-class="form-control form-control-sm"
              :clearable="false"
              maxlength="7"
              type="month"
              format="MM/YYYY"
              value-type="format"
              id="mes_ano"
              v-model="novo.mes_ano"
              @change="doChangeDate"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Valor R$" label-size="sm" label-for="vl_planej_orig">
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_planej_orig"
              v-model="novo.vl_planejado_orig"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Valor 2ª Moeda" label-size="sm" label-for="vl_planej_orig_m2">
            <b-input-group>
              <b-form-input
                size="sm"
                maxlength="20"
                id="vl_planej_orig_m2"
                v-model="novo.vl_planejado_orig_m2"
                trim
                v-mask="{
                  alias: 'numeric',
                  autoUnmask: true,
                  greedy: true,
                  radixPoint: ',',
                  groupSeparator: '.',
                  digits: 2,
                  digitsOptional: false,
                  autoGroup: true,
                  allowPlus: false,
                  allowMinus: false,
                  onUnMask: function(maskedValue) {
                    var x = maskedValue.split(',');
                    return x[0].replace(/\./g, '') + '.' + x[1];
                  },
                }"
              ></b-form-input>
              <b-input-group-append>
                <b-button size="sm" @click="doAddValorPlanejOrig" variant="success"
                  ><i class="fas fa-plus"></i
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-table
            hover
            bordered
            small
            responsive
            striped
            primary-key="planejamento_id"
            table-class="font08 table-border"
            thead-class="table-header"
            selectable
            select-mode="single"
            selected-variant="primary"
            head-variant="dark"
            empty-text="Sem dados para exibir"
            empty-filtered-text="Sem dados para exibir"
            show-empty
            :fields="campos"
            :items="dados"
          >
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(mes_ano)="data">
              {{ `${String(data.item.mes_planejamento).padStart(2, "0")}/${data.item.ano_planejamento}` }}
            </template>
            <template v-slot:cell(acoes)="data">
              <b-button size="sm" class="btn-xs" variant="primary" @click="doEditOriginal(data.item)" title="Alterar"
                ><i class="fas fa-edit"></i
              ></b-button>
              <b-button size="sm" class="btn-xs" variant="danger" @click="doDeleteOriginal(data.item)" title="Excluir"
                ><i class="fas fa-trash"></i
              ></b-button>
            </template>
          </b-table>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="() => $bvModal.hide('modal-planej-original')">Fechar</b-button>
      </template>
    </b-modal>
    <b-modal no-fade id="modal-edit-original" title="Alterar Valor" size="sm">
      <b-form-row>
        <b-col>
          <b-form-group label="Valor Planejado R$" label-size="sm" label-for="vl_planejado_orig">
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_planejado_orig"
              v-model="registro.vl_planejado_orig"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label="Valor Planejado 2ª Moeda" label-size="sm" label-for="vl_planejado_orig_m2">
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_planejado_orig_m2"
              v-model="registro.vl_planejado_orig_m2"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>

      <template v-slot:modal-footer>
        <b-button size="sm" @click="doGravarUpdate" variant="primary">Gravar</b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-edit-original')">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { baseApiUrl, showError, formatMoney } from "@/global";
import axios from "axios";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  name: "ModalPlanejOriginal",
  components: { DatePicker },
  props: {
    wbs: { type: Object, required: true },
  },
  data: function() {
    return {
      novo: {},
      isNew: false,
      registro: {
        resumo_id: 0,
        vl_planejado_orig: 0,
        vl_planejado_orig_m2: 0,
      },
      dados: [],
      campos: [
        {
          key: "index",
          label: "#",
          class: "w40-field",
        },
        { key: "mes_ano", label: "Mês/Ano", class: "w100-field" },
        {
          key: "vl_planejado_orig",
          class: "text-right w100-field",
          label: "Planej. Orig. R$",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_planejado_orig_m2",
          class: "text-right w100-field",
          label: "Planej. Orig. 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "acoes",
          class: "w100-field",
          label: "Ações",
        },
      ],
    };
  },
  methods: {
    doAddValorPlanejOrig() {
      this.novo.wbs_id = this.wbs.wbs_id;
      this.novo.programa_id = btoa(this.wbs.programa_id);
      this.novo.mes_planejamento = this.novo.mes_ano.split("/")[0];
      this.novo.ano_planejamento = this.novo.mes_ano.split("/")[1];
      axios.post(`${baseApiUrl}/bid/resumo-financeiro/valor-planej-original`, this.novo).then(() => this.doShowDados());
    },
    doChangeDate(date) {
      this.novo.mes_ano = date;
      this.$forceUpdate();
    },
    doEditOriginal(item) {
      this.registro = (({ resumo_id, vl_planejado_orig, vl_planejado_orig_m2 }) => ({
        resumo_id,
        vl_planejado_orig,
        vl_planejado_orig_m2,
      }))(item);
      this.$bvModal.show("modal-edit-original");
    },
    doDeleteOriginal(item) {
      axios
        .delete(`${baseApiUrl}/bid/resumo-financeiro/valor-planej-original?resumo_id=${item.resumo_id}`)
        .then(() => this.doShowDados());
    },
    doGravarUpdate() {
      axios
        .put(`${baseApiUrl}/bid/resumo-financeiro/valor-planej-original`, this.registro)
        .then((response) => (this.dados = response.data));
    },
    doShowDados() {
      axios
        .get(
          `${baseApiUrl}/bid/resumo-financeiro/listar-planej-original?programa_id=${btoa(
            this.wbs.programa_id
          )}&wbs_id=${this.wbs.wbs_id}`
        )
        .then((response) => (this.dados = response.data))
        .catch((err) => showError(err));

      //    Route::get('bid', 'Api\BID\ProgramaResumoApiController@listarPlanejOriginal');
    },
  },
};
</script>

<style></style>
